import styled from 'styled-components';

import { KebabMenu } from '@r1-frontend/ui-react/components/KebabMenu';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardsBlock = styled.div`
    flex-direction: column;
    width: 100%;
    position: relative;

    &:not(:last-child) {
        margin-bottom: 24px;
    }
`;

export const BlockTitle = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    margin-bottom: 12px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const CardWrapper = styled.div`
    flex-wrap: nowrap;
    align-items: center;
    padding: 12px 16px;
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgMain};

    &:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const CardImage = styled.div`
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 40px;
    margin-right: 12px;

    img {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
    }
`;

export const CardNumber = styled.p`
    ${FONTS.S};
    color: ${COLORS.ButtonPrimary};
    margin-right: auto;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const CardMenu = styled(KebabMenu)`
    width: 24px;
    height: 24px;
    margin-left: 12px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    div[data-name='popup-menu'] {
        top: 39px;
        right: -24px;
        z-index: 1;
    }
`;

export const ErrorDisconnectText = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextInfo};

    p {
        color: ${COLORS.Link};
        cursor: pointer;
    }
`;

export const DeactivatePopupActions = styled.div`
    gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        width: 100%;
    }
`;
